import {
  FIELD_TYPES,
  SCREENS_WITH_SPACERS,
  LAYOUT_IDS
} from "../../utils/constants";

const { containerSpacer } = FIELD_TYPES;

const hasSpacerFields = (fields = [], appData) =>
  SCREENS_WITH_SPACERS.includes(
    appData.data.screens[appData.screenIndex]?.name
  ) && fields.some(field => field.type === containerSpacer);

export const buildSpacerFields = (fields = [], appData) => {
  if (hasSpacerFields(fields, appData)) {
    return fields
      .reduce((prebuiltFields, field, index) => {
        if (index === 0 && field.type !== containerSpacer)
          return [
            {
              fieldLayouts: [
                { "layout-id": LAYOUT_IDS.primary, containerFields: [field] }
              ],
              links: [],
              name: "topSpacer",
              type: containerSpacer
            }
          ];

        if (field.type === containerSpacer) {
          field.fieldLayouts = [
            { "layout-id": LAYOUT_IDS.primary, containerFields: [] }
          ];
          prebuiltFields.push(field);
          return prebuiltFields;
        } else {
          prebuiltFields[
            prebuiltFields.length - 1
          ].fieldLayouts[0].containerFields.push(field);
          return prebuiltFields;
        }
      }, [])
      .filter(({ fieldLayouts }) => fieldLayouts[0].containerFields.length);
  }

  return null;
};
